/**
 * S3公開設定にしたURLの画像をBase64に変換する
 */
export default class PublicS3UrlToBase64 {
  /**
   * ### 変換
   *
   * - 変換処理の注意点ではないが、以下に注意すること
   *   - 画面表示しているimg要素取得時にキャッシュが発生しているため、CORSエラーになってしまう
   *   - キャッシュされるとOriginヘッダをつけずにimg要素のsrc属性値のURLへGETをかけてCORSになる
   *   - 回避策として、画面表示時に本メソッドを使用してDataUrlに変換したものを画面表示し、使いまわすようにする
   *
   * @param url 画像のURL
   * @param mimeType 変換するmimeType
   */
  public static async convert(url: string, mimeType: string): Promise<string> {
    let encodedImage: any = "";

    // img要素を作る
    const image: HTMLImageElement = await this.imageLoading(url);

    // img要素からcanvas要素に変換し、そこからDataURLを作る
    const canvas: HTMLCanvasElement = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    const context: CanvasRenderingContext2D | null = canvas.getContext("2d");
    if (context) {
      context.drawImage(image, 0, 0);
      encodedImage = canvas.toDataURL(mimeType);
    }
    return encodedImage;
  }

  /**
   * 画像の読込み
   *
   * Image要素はonloadに読込み後のfunctionを登録する仕様になっている
   * Promiseを返すようにラップする
   */
  private static async imageLoading(url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.onload = () => resolve(image);
      image.onerror = (e) => reject(e);
      image.src = url;
    });
  }
}
